import { render, staticRenderFns } from "./add-representative.vue?vue&type=template&id=f6b80ffe&scoped=true&"
import script from "./add-representative.vue?vue&type=script&lang=js&"
export * from "./add-representative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b80ffe",
  null
  
)

export default component.exports